import React from 'react';
import TutorialPage from './TutorialPage';
import classnames from 'classnames';

import './Pages.scss';
import { PagesChildrenProps } from '../../entities/ContentProps';

export default function Pages({ children }: PagesChildrenProps): React.ReactElement {
  return (
    <div className={classnames('pages', { pages__space: children?.edges.length <= 2 })}>
      {children?.edges?.map((page, i) => {
        return <TutorialPage key={i}>{page}</TutorialPage>;
      })}
    </div>
  );
}
